import { Card } from "@certn/cascadia-react";

import { Credentials } from "../components/Credentials";

interface Props {
  caseId: string | undefined;
}
export function CredentialsTab({ caseId }: Props) {
  return (
    <Card testID="credentials" type="large" responsive>
      <Credentials caseId={caseId || ""} />
    </Card>
  );
}
